import { LOCATION_CHANGE } from 'connected-react-router';
import * as AuthService from '../auth-service';
import {
    acceptUpdatePassword,
    acceptUpdateUserProfile,
    closeUpdatePasswordModal,
    loadUserProfileAttributes,
    rejectUpdatePassword,
    rejectUpdateUserProfile,
    UPDATE_PASSWORD_ACCEPTED,
    UPDATE_PASSWORD_SUBMITTED,
    UPDATE_USER_PROFILE_SUBMITTED,
} from './update-user-profile-state';
import { createMiddleware } from '../../../shared/redux';
import { saveUserProfile } from '../../../shared/api/users-settings-api';
import { validateUpdateProfileForm } from './update-user-profile-form.validation';
import { validateUpdatePassword } from './update-password-modal.validation';
import { match } from '../../../shared/utils/match';
import Routes from '../../router/routes.constants';

export const updateUserProfileMiddleware = createMiddleware({
    [LOCATION_CHANGE]: match((_, action) => action.payload.location.pathname, {
        [Routes.USER_PROFILE]: () => (
            AuthService.currentAuthenticatedUser()
                .then(user => loadUserProfileAttributes(user.attributes))
                .catch(() => null)
        ),
    }),

    [UPDATE_USER_PROFILE_SUBMITTED]: async (state, action) => {
        try {
            await validateUpdateProfileForm(action.payload);

            const { name, picture: pictureFile } = action.payload;
            const attributes = { name };

            const userProfile = await saveUserProfile(name, pictureFile);
            attributes.picture = userProfile.user_img_path;

            await AuthService.updateAttributes(attributes);

            return acceptUpdateUserProfile();
        } catch (error) {
            return rejectUpdateUserProfile({ error });
        }
    },

    [UPDATE_PASSWORD_SUBMITTED]: (state, action) => (
        validateUpdatePassword(action.payload)
            .then(() => AuthService.changePassword({
                currentPassword: action.payload.currentPassword,
                newPassword: action.payload.newPassword,
            }))
            .then(() => acceptUpdatePassword())
            .catch(error => rejectUpdatePassword({ error }))
    ),

    [UPDATE_PASSWORD_ACCEPTED]: () => closeUpdatePasswordModal(),
});
